<!--抄表记录列表-->
<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">抄表记录</span>
      </div>
    </div>
    <div class="content-header">
      <div class="left">
        <DatePicker
          type="date"
          format="yyyy-MM-dd"
          v-model="page.start"
          @on-change="dateChange"
          style="width: 130px"
          placeholder="开始时间"
        ></DatePicker>
        <span style="margin: 0 5px">至</span>
        <DatePicker
          type="date"
          format="yyyy-MM-dd"
          v-model="page.end"
          style="width: 130px"
          @on-change="dateChange"
          placeholder="结束时间"
        ></DatePicker>
        <Input
          v-model="page.value"
          placeholder="根据条件搜索"
          style="width: 280px; margin: 0 0 1px 5px"
          @on-enter="getData"
        >
          <Select v-model="page.cond" slot="prepend" style="width: 110px">
            <Option value="id">编号</Option>
            <!-- 0云知印 1智能运维 2手工抄表 -->
            <Option value="machine_type_name">设备型号</Option>
            <Option value="sn">设备序列号</Option>
            <Option value="site_name">站点</Option>
            <Option value="company_name">企业名称</Option>
          </Select>
        </Input>

        <Button type="primary" style="margin-left: 10px" @click="getData(1)"
          >查询</Button
        >
        <Button style="margin: 0 5px" @click="reset">重置</Button>
      </div>
      <div class="right">
        <Poptip title="导出Excel" placement="right" trigger="hover">
          <Button style="margin: 2px 5px 0 0">导出报表</Button>
          <div slot="content">
            <Button
              type="primary"
              style="margin-right: 5px"
              @click="exportData(0)"
              >导出当前页</Button
            >
            <Button type="success" @click="exportData(1)">导出所有页</Button>
          </div>
        </Poptip>
        <Poptip trigger="hover" placement="left">
          <Button type="primary">新增抄表记录</Button>
          <div slot="content">
            <Button type="info" @click="modal1Init">远程获取</Button>
            <Button type="info" @click="modal2Init" style="margin-left: 5px"
              >手工录入</Button
            >
          </div>
        </Poptip>
      </div>
    </div>
    <div>
      <Table :columns="columns" :data="data" :loading="tableLoading">
        <template slot-scope="{ row }" slot="message">
          <Poptip
            word-wrap
            width="300"
            :content="row.message"
            trigger="hover"
            transfer
          >
            <div style="width: 100px">
              <p
                style="
                  width: 100px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
              >
                {{ row.message }}
              </p>
            </div>
          </Poptip>
        </template>
      </Table>
      <div class="t-right">
        <Page
          @on-change="pageChange"
          @on-page-size-change="sizeChange"
          :total="total"
          :current="page.p + 1"
          show-elevator
          show-sizer
          show-total
        />
      </div>
      <Spin fix v-if="tableLoading">
        <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
        <div>加载中...</div>
      </Spin>
    </div>
    <Modal title="远程获取" width="720" v-model="modal1.visible">
      <div style="width: 150px; margin: 0 0 5px 0">
        <Input placeholder="模糊匹配" @on-enter="searchModal1Machine" />
      </div>
      <Table
        :columns="modal1.columns"
        @on-selection-change="modal1Select"
        height="500"
        :data="modal1.machine"
      ></Table>
      <div slot="footer">
        <Button @click="modal1.visible = false">取消</Button>
        <Button @click="modal1Ok" type="primary">确定</Button>
      </div>
    </Modal>

    <Modal title="手工录入" width="520" v-model="modal2.visible">
      <Form
        ref="form2"
        :model="modal2.data"
        :rules="modal2.rules"
        :label-width="100"
        inline
      >
        <FormItem prop="machine_id" label="设备:">
          <Select
            v-model="modal2.data.machine_id"
            style="width: 350px"
            filterable
          >
            <Option
              v-for="(item, index) in modal2.machine"
              :key="index"
              :value="item.id"
              :label="item.sn"
            >
              <div>
                <div>
                  {{ item.sn }} - <span>{{ item.machine_type_name }}</span> -
                  <span>{{
                    item.meter_charge_name ? item.meter_charge_name : ""
                  }}</span>
                </div>
                <div style="color: #ccc">
                  {{ item.address }}-{{ item.address_detail }}
                </div>
              </div>
            </Option>
          </Select>
        </FormItem>
        <FormItem prop="create_time" label="计数日期:">
          <DatePicker
            type="date"
            v-model="modal2.data.create_time"
            placeholder="计数日期..."
            style="width: 120px"
          ></DatePicker>
        </FormItem>
        <FormItem prop="total" label="总计数:">
          <InputNumber
            :min="0"
            v-model="modal2.data.total"
            placeholder="总计数..."
            style="width: 120px"
          ></InputNumber>
        </FormItem>
        <FormItem prop="black_num" label="黑白计数:">
          <InputNumber
            :min="0"
            v-model="modal2.data.black_num"
            placeholder="黑白计数..."
            style="width: 120px"
          ></InputNumber>
        </FormItem>
        <FormItem prop="color_num" label="彩色记数:">
          <InputNumber
            :min="0"
            v-model="modal2.data.color_num"
            placeholder="彩色记数..."
            style="width: 120px"
          ></InputNumber>
        </FormItem>
        <FormItem prop="black_a3_num" label="A3黑白:">
          <InputNumber
            :min="0"
            v-model="modal2.data.black_a3_num"
            placeholder="A3黑白..."
            style="width: 120px"
          ></InputNumber>
        </FormItem>
        <FormItem prop="color_a3_num" label="A3彩色:">
          <InputNumber
            :min="0"
            v-model="modal2.data.color_a3_num"
            placeholder="A3彩色..."
            style="width: 120px"
          ></InputNumber>
        </FormItem>
        <FormItem prop="both_num" label="双色计数:">
          <InputNumber
            :min="0"
            v-model="modal2.data.both_num"
            placeholder="双色计数..."
            style="width: 120px"
          ></InputNumber>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="modal2.visible = false">取消</Button>
        <Button @click="modal2Ok" v-preventReClick type="primary">确定</Button>
      </div>
    </Modal>

    <Modal title="设备耗材" width="520" v-model="hc.visible">
      <Row>
        <Col span="12">
          <Card style="width: 99%" title="纸盒状态">
            <Row v-for="(item, index) in hc.data.show_tray" :key="index">
              <Col span="8">{{ ConsumablesKey[item.name] }}</Col>
              <Col span="16">
                <Progress :percent="item.value" status="active" />
              </Col>
            </Row>
          </Card>
        </Col>
        <Col span="12">
          <Card style="width: 99%" title="碳粉状态">
            <Row v-for="(item, index) in hc.data.show_toner" :key="index">
              <Col span="8">{{ ConsumablesKey[item.name] }}</Col>
              <Col span="16">
                <Progress :percent="item.value" status="active" />
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Modal>
    <Drawer title="详情" :closable="false" v-model="drawer.status" :width="500">
      <div v-for="(item, key) in drawer.appendix" :key="key">
        <img :src="item" alt srcset style="max-width: 100%" />
      </div>
    </Drawer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import excel from '@/libs/excel'
import { verifyDate } from '@/libs/util'
export default {
  data () {
    return {
      hc: {
        visible: false,
        data: {}
      },
      tableLoading: false,
      page: {
        p: 0,
        l: 10,
        start: '',
        end: '',
        cond: 'id',
        value: ''
      },
      // 远程获取
      modal1: {
        data: {},
        rules: {},
        machine: [],
        columns: [
          { key: 'id', width: 35, type: 'selection' },
          { key: 'id', width: 80, title: '编号' },
          { key: 'machine_type_name', width: 110, title: '设备型号' },
          { key: 'sn', width: 120, title: '设备序列号' },
          { key: 'site_name', tooltip: true, title: '站点' },
          {
            key: 'address',
            tooltip: true,
            title: '地址',
            render: (h, data) => {
              return h(
                'span',
                {},
                `${data.row.address}-${data.row.address_detail}`
              )
            }
          }
        ],
        selection: [],
        visible: false
      },
      // 手动获取
      modal2: {
        data: {},
        rules: {
          machine_id: [
            {
              required: true,
              type: 'number',
              message: '请选择设备',
              trigger: 'change'
            }
          ],
          create_time: [
            {
              required: true,
              type: 'date',
              message: '请选择计数日期',
              trigger: 'blur'
            }
          ],
          total: [
            {
              required: true,
              type: 'number',
              message: '请填写总计数',
              trigger: 'blur'
            }
          ],
          black_num: [
            {
              required: true,
              type: 'number',
              message: '请填写黑白计数',
              trigger: 'blur'
            }
          ]
          // color_num: [
          //   {
          //     required: true,
          //     type: "number",
          //     message: "请填写彩色计数",
          //     trigger: "blur"
          //   }
          // ],
          // black_a3_num: [
          //   {
          //     required: true,
          //     type: "number",
          //     message: "请填写黑白A3计数",
          //     trigger: "blur"
          //   }
          // ],
          // color_a3_num: [
          //   {
          //     required: true,
          //     type: "number",
          //     message: "请填写彩色A3计数",
          //     trigger: "blur"
          //   }
          // ],
          // both_num: [
          //   {
          //     required: true,
          //     type: "number",
          //     message: "请填写双色计数",
          //     trigger: "blur"
          //   }
          // ]
        },
        machine: [],
        visible: false
      },
      columns: [
        { key: 'id', width: 80, title: '编号' },
        {
          key: 'create_time',
          width: 135,
          title: '抄表日期',
          render: (h, data) => {
            return h('span', {}, this.$moment(data.row.create_time))
          }
        },
        // 0 自动 1 远程获取 2 手工录入
        {
          key: 'type',
          title: '抄表方式',
          width: 90,
          render: (h, data) => {
            let temp = {
              0: '自动抄表',
              1: '远程获取',
              2: '手工录入'
            }
            return h('span', {}, temp[data.row.type])
          }
        },
        // 0云知印 1智能运维 2手工抄表
        {
          key: 'meter',
          width: 85,
          title: '设备类型',
          render: (h, data) => {
            let temp = {
              0: '云知印',
              1: '智能运维',
              2: '手工抄表'
            }
            return h('span', {}, temp[data.row.meter])
          }
        },
        { key: 'machine_type_name', width: 110, title: '设备型号' },
        { key: 'sn', width: 120, title: '设备序列号' },
        { key: 'site_name', width: 180, title: '站点' },
        {
          key: 'company_name',
          title: '企业名称',
          width: 200,
          render: (h, data) => {
            return h(
              'p',
              {
                style: {
                  width: '200px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  padding: 0,
                  margin: 0
                }
              },
              data.row.company_name ? data.row.company_name : '-'
            )
          }
        },
        { key: 'total', title: '总计数', width: 80 },
        { key: 'black_num', title: '黑白计数', width: 90 },
        { key: 'color_num', title: '彩色计数', width: 90 },
        { key: 'black_a3_num', title: 'A3黑白', width: 90 },
        { key: 'color_a3_num', title: 'A3彩色', width: 90 },
        { key: 'both_num', title: '双色计数', width: 90 },
        {
          key: 'status',
          width: 90,
          title: '状态',
          render: (h, data) => {
            return h(
              'span',
              {
                style: { color: data.row.status ? '#19be6b' : '#ed4014' }
              },
              data.row.status ? '成功' : '获取中'
            )
          }
        },
        {
          title: '备注',
          key: 'message',
          width: 300,
          slot: 'message'
        },
        {
          key: 'operate',
          width: 185,
          title: '操作',
          fixed: 'right',
          export_ignore: true,
          render: (h, data) => {
            let temp = [
              h(
                'Button',
                {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.DeleteMeterLog({ id: data.row.id }).then((res) => {
                        this.$Message.success('删除成功')
                        this.getData()
                      })
                    }
                  }
                },
                '删除'
              )
            ]
            if (!data.row.status) {
              temp.push(
                h(
                  'Button',
                  {
                    props: {
                      type: 'success',
                      size: 'small'
                    },
                    style: {
                      marginLeft: '5px'
                    },
                    on: {
                      click: () => {
                        console.log(data.row.status)
                        if (data.row.status !== 0 && data.row.status !== 4) {
                          this.$Message.error('设备已过期,无法获取')
                        } else {
                          this.regain(data.row)
                        }
                      }
                    }
                  },
                  '重新获取'
                )
              )
            }
            if (data.row.toner && data.row.tray) {
              temp.push(
                h(
                  'Button',
                  {
                    props: {
                      type: 'info',
                      size: 'small'
                    },
                    style: {
                      marginLeft: '5px'
                    },
                    on: {
                      click: () => {
                        this.openHC(JSON.parse(JSON.stringify(data.row)))
                      }
                    }
                  },
                  '查看耗材'
                )
              )
            }
            if (data.row.appendix) {
              temp.push(
                h(
                  'Button',
                  {
                    props: {
                      size: 'small',
                      type: 'primary'
                    },
                    style: { marginLeft: '5px' },
                    on: {
                      click: () => {
                        this.openDrawer(data.row.appendixItem)
                      }
                    }
                  },
                  '附件'
                )
              )
            }
            return h(
              'div',
              {
                style: {
                  display: 'flex'
                }
              },
              [temp]
            )
          }
        }
      ],
      data: [],
      total: 0,
      drawer: {
        status: false,
        appendix: []
      },
      ConsumablesKey: {
        black: '黑色',
        magenta: '红色',
        yellow: '黄色',
        cyan: '青色',
        manual: '手送台',
        tray1: '纸盒1',
        tray2: '纸盒2',
        tray3: '纸盒3',
        tray4: '纸盒4'
      },
      dateOption: {
        disabledDate (date) {
          return date && date.valueOf() > Date.now()
        }
      }
    }
  },
  mounted () {
    let now = new Date()
    let last = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate()
    this.page.start = this.$moment(now, 'YYYY') + '-01-01'
    this.page.end = this.$moment(now, 'YYYY-MM') + `-${last}`
    this.getData()
  },
  methods: {
    searchModal1Machine (e) {
      let words = e.target.value,
        result = []
      this.modal1.all.map((item) => {
        if (
          `${item['id']}`.indexOf(words) >= 0 ||
          `${item['machine_type_name']}`.indexOf(words) >= 0 ||
          `${item['sn']}`.indexOf(words) >= 0 ||
          `${item['site_name']}`.indexOf(words) >= 0 ||
          `${item['address']}`.indexOf(words) >= 0 ||
          `${item['address_detail']}`.indexOf(words) >= 0
        ) {
          result.push(item)
        }
      })
      this.modal1.machine = result
    },
    openDrawer (appendix = []) {
      this.drawer.appendix = appendix
      this.drawer.status = true
    },
    openHC (data) {
      console.log(data)
      data.toner = JSON.parse(data.toner)
      data.show_toner = []
      data.tray = JSON.parse(data.tray)
      data.show_tray = []
      data.toner.map((item) => {
        data.show_toner.push({
          name: item.split('_')[0],
          value: parseInt(item.split('_')[1])
        })
      })
      data.tray.map((item) => {
        data.show_tray.push({
          name: item.split('_')[0],
          value: parseInt(item.split('_')[1])
        })
      })
      this.hc = {
        visible: true,
        data: data
      }
    },
    regain (data) {
      this.MeterRegain({ id: data.id, sn: data.sn, type: 1 }).then((res) => {
        if (res.length) {
          this.$Message.error({
            content: `${res.join(',')},设备未连接,无法获取抄表数据`,
            duration: 5
          })
        }
        this.getData()
      })
    },
    modal1Select (list) {
      let temp = []
      list.map((item) => {
        temp.push({ machine_id: item.id, type: 1, sn: item.sn })
      })
      this.modal1.selection = temp
    },
    // 远程
    modal1Ok () {
      console.log(this.modal1.selection)
      if (this.modal1.selection.length) {
        this.PutMeter(this.modal1.selection).then((res) => {
          this.$Message.success('等待获取')
          this.modal1.visible = false
          this.getData()
        })
      }
    },
    // 手工
    modal2Ok () {
      this.$refs.form2.validate((valid) => {
        if (valid) {
          let data = JSON.parse(JSON.stringify(this.modal2.data))
          data.type = 2
          data.status = 1
          data.create_time = this.$moment(
            this.modal2.data.create_time,
            'YYYY-MM-DD HH:mm:ss'
          )
          this.PutMeterManual(data).then((res) => {
            this.$Message.success('新增成功')
            this.modal2.visible = false
            this.getData()
          })
        }
      })
    },
    modal1Init () {
      this.GetMeterMachine({ type: 1 }).then((res) => {
        this.modal1.all = res
        this.modal1.machine = res
      });
      (this.modal1.data = {}), (this.modal1.selection = [])
      this.modal1.visible = true
    },
    modal2Init () {
      this.GetMeterMachine({ type: 2 }).then((res) => {
        this.modal2.machine = res
      });
      (this.modal2.data = {
        create_time: new Date(),
        total: null,
        black_num: null,
        color_num: null,
        black_a3_num: null,
        color_a3_num: null,
        both_num: null
      }),
      (this.modal2.visible = true)
    },
    reset () {
      let now = new Date()
      let last = new Date(now.getFullYear(), now.getMonth() + 1, 0).getDate()
      this.page = {
        p: 0,
        l: 10,
        cond: 'id',
        value: ''
      }
      this.page.start = this.$moment(now, 'YYYY-MM') + '-01'
      this.page.end = this.$moment(now, 'YYYY-MM') + `-${last}`
      this.getData()
    },
    sizeChange (l) {
      this.page.l = l
      this.getData()
    },
    pageChange (p) {
      this.page.p = p - 1
      this.getData()
    },
    getData (filter) {
      if (filter) {
        this.page.p = 0
      }
      if (verifyDate(this.page.start, this.page.end)) {
        this.$Message.error('开始时间不能大于结束时间')
        return
      }
      this.tableLoading = true
      this.page.start = this.$moment(this.page.start, 'YYYY-MM-DD')
      this.page.end = this.$moment(this.page.end, 'YYYY-MM-DD')
      this.GetMeterLog(this.page).then((res) => {
        this.tableLoading = false
        this.total = res.total
        this.data = res.data
      })
    },
    dateChange (value) {
      this.date = value
    },
    getDataParams () {
      try {
        let temp = JSON.parse(JSON.stringify(this.page))
        temp.l = 10000
        temp.p = 0
        temp.start = this.date[0]
        temp.end = this.date[1]
        return temp
      } catch (error) {
        console.log(error)
      }
    },
    exportData (is_all) {
      let params = {
        title: [],
        key: [],
        autoWidth: true,
        filename: '抄表记录'
      }
      this.columns.map((item) => {
        if (item.export_ignore) {
          return
        }
        params.title.push(item.title)
        params.key.push(item.key)
      })
      if (is_all) {
        let resCond = this.getDataParams()
        this.tableLoading = true
        this.GetMeterLog(resCond).then((res) => {
          this.tableLoading = false
          params.data = this.formatExportData(res.data)
          excel.export_array_to_excel(params)
        })
      } else {
        params.data = this.formatExportData(
          JSON.parse(JSON.stringify(this.data))
        )
        excel.export_array_to_excel(params)
      }
    },
    formatExportData (data) {
      data.map((item) => {
        item.create_time = this.$moment(item.create_time)
        item.type =
          item.type == 0
            ? '自动抄表'
            : item.type == 1
              ? '远程获取'
              : '手工录入'
        item.meter =
          item.type == 0 ? '云知印' : item.type == 1 ? '智能运维' : '手工抄表'
        item.status = item.status == 1 ? '成功' : '获取中'
      })
      return data
    },
    ...mapActions([
      'GetMeterLog',
      'GetMeterMachine',
      'PutMeter',
      'MeterRegain',
      'DeleteMeterLog',
      'PutMeterManual'
    ])
  },
  computed: mapGetters({
    meterLog: 'meterLog'
  }),
  watch: {
    meterLog () {
      this.getData()
    }
  }
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
